<template>
    <div>
        <Header></Header>

        <router-view></router-view>

        <ModalPrensa></ModalPrensa>
        <Footer></Footer>
    </div>
</template>

<script>
import Footer from "../components/Footer.vue";
import Header from "../components/Header.vue";
import ModalPrensa from "../components/ModalPrensa.vue";

export default {
    components: { Header, ModalPrensa, Footer },
    metaInfo() {
        return {
            title: "Media Room Renault Argentina",
            titleTemplate: "%s | Media Room Renault Argentina",
            meta: [
                {
                    property: "og:title",
                    content: "Media Room Renault Argentina",
                },
                {
                    property: "og:site_name",
                    content: "Media Room Renault Argentina",
                },
                { property: "og:type", content: "website" },
                { name: "robots", content: "index,follow" },
            ],
        };
    },
    watch: {
        $route() {
            $("#navbarRenault").collapse("hide");
        },
    },
};
</script>
